"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8117],{

/***/ 98117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ChipBlock_ChipBlock; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./components/TinaImage/index.ts + 1 modules
var TinaImage = __webpack_require__(4605);
;// CONCATENATED MODULE: ./components/Chip/Chip.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2rem;\n    padding: 1rem 2rem;\n    border-radius: 4rem;      \n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n  border-radius: 2rem;\n  ",
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border: 2px solid ",
        ";\n  cursor: pointer;\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}



const Span = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-736feb01-0"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject());
}, (param)=>{
    let { theme , active  } = param;
    return active ? theme.themeColors.fg : "transparent";
}, (param)=>{
    let { theme , active  } = param;
    return active ? theme.themeColors.bg : theme.themeColors.fg;
}, (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
}, (param)=>{
    let { theme , active , hover  } = param;
    return hover && !active && theme.themeColors.fg;
}, (param)=>{
    let { theme , active , hover  } = param;
    return hover && !active && theme.themeColors.bg;
});
const Chip = (param)=>{
    let { text ="" , active =false , hover =false , className ="" , onEnter =undefined , onExit =undefined  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
        active: active,
        hover: hover,
        className: className,
        onMouseEnter: onEnter,
        onMouseLeave: onExit,
        children: text
    });
};
/* harmony default export */ var Chip_Chip = (Chip);

;// CONCATENATED MODULE: ./components/Chip/index.ts


// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
;// CONCATENATED MODULE: ./blocks/ChipBlock/ChipBlock.tsx

function ChipBlock_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100vh;\n"
    ]);
    ChipBlock_templateObject = function() {
        return data;
    };
    return data;
}
function ChipBlock_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-template-areas:\n    '. . .'\n    '. a .'\n    '. . .';\n  "
    ]);
    ChipBlock_templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  height: 100%;\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n  grid-template-areas:\n    '. . .'\n    '. . .'\n    '. a .';\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.5rem;     \n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  padding: 0.25rem;\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: 0;\n  left: 0;\n  width: 100%;\n  position: absolute;\n  #cgr {\n    height: 90%;\n    width: 100%;\n    top: 5%;\n  }\n  #berrien {\n    width: 590px;\n    height: 90%;\n    top: 5%;\n  }\n  #stone {\n    width: 594px;\n    height: 334px;\n    right: 0px;\n    bottom: 3%;\n  }\n  #racism {\n    width: 640px;\n    height: 94%;\n    top: 3%;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  #speaker {\n    width: 696px;\n    height: 462px;\n    left: 10%;\n    top: 5%;\n  }\n  #trauma {\n    width: 590px;\n    height: 294px;\n    top: 5%;\n    right: 3%;\n  }\n  #talks {\n    width: 570px;\n    height: 570px;\n    left: 0px;\n  }\n  #covid {\n    width: 433.5px;\n    height: 339px;\n    top: 30%;\n    right: 3%;\n  }\n  #voices {\n    width: 534px;\n    height: 596px;\n    top: 3%;\n    left: 25%;\n  }\n  #blm {\n    width: 696px;\n    height: 90%;\n    top: 5%;\n    right: 0px;\n  }\n  height: 100vh;\n  z-index: 1;\n  img {\n    object-fit: cover;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.5rem;\n    padding-bottom: .5rem;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  padding: 1rem;\n  padding-bottom: 3rem;\n  height: 100%;\n  position: relative;\n  grid-area: a;\n  align-self: center;\n  justify-self: center;\n  z-index: 2;\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display:block;\n    visibility: ",
        ";\n    opacity: ",
        ";\n    transition: opacity .2s linear;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: hidden;\n  display: none;\n  padding: 0.5rem;\n  z-index: 0;\n  position: absolute;\n  object-fit: cover;\n\n  ",
        "\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display:none;\n    visibility: hidden;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: block;\n  width: 100%;\n  z-index: 1;\n  top: 0;\n  object-fit: cover;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transition: opacity 0.2s linear;\n  ",
        "\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}






const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3789be44-0"
})(ChipBlock_templateObject());
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3789be44-1"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(ChipBlock_templateObject1());
});
const ChipPadding = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3789be44-2"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject3());
});
const ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3789be44-3"
})(_templateObject5());
const ChipContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3789be44-4"
})(_templateObject7(), (0,padding/* blockW */.g5)(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject6());
});
const HoverImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3789be44-5"
})(_templateObject9(), (param)=>{
    let { theme , show  } = param;
    return theme.mq.md(_templateObject8(), show ? "visible" : "hidden", show ? "1" : "0");
});
const LinkedHoverImage = (0,styled_components_browser_esm/* default */.ZP)(TinaImage/* default */.Z).withConfig({
    componentId: "sc-3789be44-6"
})(_templateObject10());
const LinkedMobileHoverImage = (0,styled_components_browser_esm/* default */.ZP)(TinaImage/* default */.Z).withConfig({
    componentId: "sc-3789be44-7"
})(_templateObject12(), (param)=>{
    let { show  } = param;
    return show ? "visible" : "hidden";
}, (param)=>{
    let { show  } = param;
    return show ? "1" : "0";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject11());
});
const sections = {
    cgr: {
        title: "CGR Story"
    },
    berrien: {
        title: "Berrien County"
    },
    stone: {
        title: "Death Gap"
    },
    racism: {
        title: "Racism"
    },
    speaker: {
        title: "Speaker Series"
    },
    trauma: {
        title: "Trauma"
    },
    talks: {
        title: "Brave Talks"
    },
    covid: {
        title: "Covid-19"
    },
    voices: {
        title: "Community Voices"
    },
    blm: {
        title: "Black Lives Matter"
    }
};
const keys = Object.keys(sections);
const ChipBlock = ()=>{
    const [shownImage, setShownImage] = (0,react.useState)("cgr");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipContainer, {
                    children: keys.map((key)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipPadding, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_Chip, {
                                onEnter: ()=>{
                                    setShownImage(key);
                                },
                                active: shownImage == key,
                                text: sections[key].title
                            })
                        }, key);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: keys.map((key)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverImageWrapper, {
                                    id: "".concat(key),
                                    show: shownImage == key,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedHoverImage, {
                                        alt: "hover image",
                                        src: "/uploads/chip_assets/lg/".concat(key, ".jpg"),
                                        layout: "fill"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedMobileHoverImage, {
                                    alt: "mobile hover image",
                                    id: "".concat(key, "_mobile"),
                                    show: shownImage == key,
                                    layout: "fill",
                                    src: "/uploads/chip_assets/sm/".concat(key, ".jpg")
                                })
                            ]
                        }, key);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ChipBlock_ChipBlock = (ChipBlock);

;// CONCATENATED MODULE: ./blocks/ChipBlock/index.ts



/***/ }),

/***/ 3185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GfxImage_GfxImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/GfxImage/GfxImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const GfxImage = (param)=>{
    let { layout , quality , src , width =0 , height =0 , objectFit , blurDataURL , placeholder ="empty" , alt , ...rest } = param;
    if (!src) {
        return null;
    }
    const isLayoutFill = layout === "fill";
    const isSvg = src.includes(".svg");
    const imageProps = {
        layout,
        ...rest,
        ...isSvg && {
            unoptimized: true
        },
        ...placeholder === "blur" && {
            blurDataURL: blurDataURL
        },
        ...objectFit !== "none" && {
            style: {
                objectFit
            }
        },
        ...!isLayoutFill && {
            width: width,
            height: height
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: src,
        placeholder: placeholder,
        alt: alt,
        quality: quality,
        ...imageProps
    });
};
/* harmony default export */ var GfxImage_GfxImage = ((0,styled_components_browser_esm/* default */.ZP)(GfxImage).withConfig({
    componentId: "sc-2250b3a7-0"
})(_templateObject()));

;// CONCATENATED MODULE: ./components/GfxImage/index.ts



/***/ }),

/***/ 4605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TinaImage_TinaImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./components/GfxImage/index.ts + 1 modules
var GfxImage = __webpack_require__(3185);
;// CONCATENATED MODULE: ./components/TinaImage/TinaImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  width: 100%;\n  padding: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}




const Container = (0,styled_components_browser_esm/* default */.ZP)(GfxImage/* default */.Z).withConfig({
    componentId: "sc-eb0d1e3b-0"
})(_templateObject1(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject());
});
const TinaImage = (param)=>{
    let { src , layout =undefined , width =1024 , height =768 , ...props } = param;
    if (!src) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        layout: layout,
        width: width,
        height: height,
        ...props,
        src: src
    });
};
/* harmony default export */ var TinaImage_TinaImage = (TinaImage);

;// CONCATENATED MODULE: ./components/TinaImage/index.ts



/***/ })

}]);